import { wrapClientApiCall } from '../../../utils'

export const editOrderItem = ({ order_id, producerproduct_id, quantity }) => {
    return wrapClientApiCall({
        actionRoot: 'EDIT_ORDER_ITEM',
        url: `api/orders/update-item?order_id=${order_id}&producerproduct_id=${producerproduct_id}&quantity=${quantity}`,
        successPayload: ({ updatedDoc }) => ({ order: updatedDoc }),
    })
}
